<template>
  <form id="passwordform" v-if="!showImageUpload">
    <label for="password">Enter Password: </label>
    <input name="password" id="password" />
  </form>
  <ImageUpload msg="Welcome to Your Vue.js App" v-if="showImageUpload" />
</template>

<script>
// import ImageUpload from "./components/ImageUpload.vue";
import ImageUpload from "./components/ImageUpload-Github.vue";

export default {
  name: "App",
  components: {
    ImageUpload,
  },
  data() {
    return {
      showImageUpload: false,
    };
  },
  methods: {
    passwordEnter() {
      if (this.$store.state.password === process.env.VUE_APP_PASSWORD) {
        this.showImageUpload = true;
      }
    },
  },
  mounted() {
    this.passwordEnter();
    document.querySelector("#passwordform").addEventListener("change", () => {
      this.$store.commit("setPassword", document.querySelector("#password").value);
      this.passwordEnter();
    });
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
input {
  border: none;
  background: rgb(238, 238, 238);
  padding: 10px;
  display: inline-block;
  max-width: 500px;
}
</style>
